import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { UTILS__image } from '@/utils/UTILS__image';
import { not_implemented_type } from '@shared/asserts/utils_asserts';
import { useState } from 'react';
import { ENUM__image_compare_mode } from '../grid2d_sidebar_image_compare/ENUM__image_compare_mode';
import { IMAGE_COMPARE__mode_difference } from '../grid2d_sidebar_image_compare/modes/IMAGE_COMPARE__mode_difference';
import { IMAGE_COMPARE__mode_side_by_side } from '../grid2d_sidebar_image_compare/modes/IMAGE_COMPARE__mode_side_by_side';
import { IMAGE_COMPARE__mode_slider } from '../grid2d_sidebar_image_compare/modes/IMAGE_COMPARE__mode_slider';
import { GRID2D_GALLERY__image_empty } from './GRID2D_GALLERY__image_empty';
import { GRID2D_GALLERY__image_with_content } from './GRID2D_GALLERY__image_with_content';

export function GRID2D_GALLERY__image_master() {
  const { grid2d_image_compare__mode, grid2d_image_compare__image_a, global__grid2d_gallery_cell_current } = use_slice_ui([
    'grid2d_image_compare__mode',
    'grid2d_image_compare__image_a',
    'global__grid2d_gallery_cell_current',
  ]);

  const [image_a, set_image_a] = useState(ENUM__html_ref_stub.IMAGE);
  const [image_b, set_image_b] = useState(ENUM__html_ref_stub.IMAGE);

  /*
   *
   */

  use_effect(() => {
    if (grid2d_image_compare__mode == ENUM__image_compare_mode.NONE) return set_image_a(ENUM__html_ref_stub.IMAGE);

    UTILS__image.load_for_asset(grid2d_image_compare__image_a).then(image => set_image_a(image));
  }, [grid2d_image_compare__image_a, grid2d_image_compare__mode]);

  use_effect(() => {
    if (global__grid2d_gallery_cell_current.hash_sha256_content.is_empty_hash_sha256()) return set_image_b(ENUM__html_ref_stub.IMAGE);
    if (global__grid2d_gallery_cell_current.image.is_stub()) return set_image_b(ENUM__html_ref_stub.IMAGE);

    UTILS__image.load_for_asset(global__grid2d_gallery_cell_current.image).then(image => set_image_b(image));
  }, [global__grid2d_gallery_cell_current]);

  /*
   *
   */

  function render_view() {
    let out = null;

    switch (grid2d_image_compare__mode) {
      case ENUM__image_compare_mode.NONE:
        out = (
          <>
            <GRID2D_GALLERY__image_empty />
            <GRID2D_GALLERY__image_with_content />
          </>
        );
        break;
      case ENUM__image_compare_mode.SIDE_BY_SIDE:
        out = (
          <IMAGE_COMPARE__mode_side_by_side
            {...{ image_a, image_b }}
            image_a_dto={grid2d_image_compare__image_a}
            image_b_dto={global__grid2d_gallery_cell_current.image}
          />
        );
        break;
      case ENUM__image_compare_mode.DIFFERENCE:
        out = <IMAGE_COMPARE__mode_difference {...{ image_a, image_b }} />;
        break;
      case ENUM__image_compare_mode.SLIDER:
        out = <IMAGE_COMPARE__mode_slider {...{ image_a, image_b }} />;
        break;

      default:
        not_implemented_type(grid2d_image_compare__mode);
    }

    return out;
  }

  return render_view();
}
